import { LookupModelSearchEvent } from "@mcleod/components";
import { getDispatchControlBoolean } from "@mcleod/general";
import {
    AutogenLayoutBrokerageRevenueResponsibilityReport
} from "./autogen/AutogenLayoutBrokerageRevenueResponsibilityReport";

export class BrokerageRevenueResponsibilityReport extends AutogenLayoutBrokerageRevenueResponsibilityReport {
    private _steamshipsVisible = false;

    override onLoad(): void {
        this._steamshipsVisible = getDispatchControlBoolean("is_container_active", false);
        this.excludeabletextboxSteamshipLines.visible = this._steamshipsVisible;
        this.textboxInclude.visible = this._steamshipsVisible;

        this.textboxDateType.selectedItem = this.textboxDateType.items[1];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0];
        this.textboxInclude.selectedItem = this.textboxInclude.items[0];
    }

    private onChangeHierarchyLevel() {
        const isTextEmptyOrWildcard = !(this.textboxHierarchyLevel.text.trim() !== "*" &&
            this.textboxHierarchyLevel.lookupModelData?.length > 0);
        if (isTextEmptyOrWildcard) this.excludabletextboxH.textbox.clear();
        this.excludabletextboxH.textbox.enabled = !isTextEmptyOrWildcard;
    }

    private textboxSteamshipLinesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_steamship = "Y"
    }

    private textboxHierarchyCodesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.hierarchy_level = this.textboxHierarchyLevel.getFirstLookupModelData()?.get("level_number");
    }
}
